// Store the EntityTypeId for the possible EntityTypes

export const ENTITYTYPES = {

	ProductSkus: 0,
	ProductFamily: 1,
	CountryregistrationCountry: 2,
	ComplianceRegulatorydocuments: 3,
	ComplianceStandards: 4,
	SystematicReview: 5,
	CountryregistrationOperator: 6,
	CountryregistrationCertificate: 7,
	ReferenceManager: 8,
};